<template>
  <div class="l-container">
    <!-- <div>{{obj}}</div> -->

    <p class="m-label">家庭選択
      <i class="fa fa-sort-alpha-desc"></i>ソート<i class="fa fa-fw fa-angle-down"></i>
      <span>
        <template v-if="this.sortColumn2 === 'id'">ID</template>
        <template v-if="this.sortColumn2 === 'name'">名前</template>
        <template v-if="this.sortColumn2 === 'kana'">かな</template>
        <template v-if="this.sortColumn2 === 'pref'">都道府県</template>
        <template v-if="this.sortColumn2 === 'address'">住所</template>
        <template v-if="this.sortColumn2 === 'tel1'">TEL1</template>
        <template v-if="this.sortColumn2 === 'created_at'">作成日</template>
         : {{sortState2}}
      </span>
    </p>

    <div class="index-box FamilyfilesIndex" @scroll="offset">
      <table-c>
        <tr-c slot="tr-th">
          <td-c><input v-model="search2.id" type="text" @keyup="searchTable2()" placeholder="検索"></td-c>
          <td-c><input v-model="search2.name" type="text" @keyup="searchTable2()"></td-c>
          <td-c><input v-model="search2.kana" type="text" @keyup="searchTable2()"></td-c>
          <td-c class="select">
            <multiselect @select="searchTable2()" v-model="watchSearch2.pref" :options="pref" label="name" placeholder="" :show-labels="false"></multiselect>
          </td-c>
          <td-c><input v-model="search2.address" type="text" @keyup="searchTable2()"></td-c>
          <td-c><input v-model="search2.tel1" type="text" @keyup="searchTable2()"></td-c>
          <td-c><input v-model="search2.created_at" type="text" @keyup="searchTable2()"></td-c>
        </tr-c>

        <tr-c slot="tr-th">
          <td-c><input v-model="search2.not_id" type="text" @keyup="searchTable2()" placeholder="除外"></td-c>
          <td-c><input v-model="search2.not_name" type="text" @keyup="searchTable2()"></td-c>
          <td-c><input v-model="search2.not_kana" type="text" @keyup="searchTable2()"></td-c>
          <td-c class="select">
            <multiselect @select="searchTable2()" v-model="watchSearch2.not_pref" :options="pref" label="name" placeholder="" :show-labels="false"></multiselect>
          </td-c>
          <td-c><input v-model="search2.not_address" type="text" @keyup="searchTable2()"></td-c>
          <td-c><input v-model="search2.not_tel1" type="text" @keyup="searchTable2()"></td-c>
          <td-c><input v-model="search2.not_created_at" type="text" @keyup="searchTable2()"></td-c>
        </tr-c>

        <tr-c slot="tr-th">
          <th-c @click.native='sort2("id")'>ID</th-c>
          <th-c @click.native='sort2("name")'>名前</th-c>
          <th-c @click.native='sort2("kana")'>かな</th-c>
          <th-c @click.native='sort2("pref")'>都道府県</th-c>
          <th-c @click.native='sort2("address")'>住所</th-c>
          <th-c @click.native='sort2("tel1")'>TEL1</th-c>
          <th-c @click.native='sort2("created_at")'>作成日</th-c>
        </tr-c>

        <tr-c slot="tr-td" @click.native="getId(family)" v-for="(family, index) in orderedFamilies" :key="family.id">
          <template v-if="familyfile.family_id === family.id">
            <td-c class="clicked">{{family.id}}</td-c>
            <td-c class="clicked">{{family.f_name}} {{family.l_name}}</td-c>
            <td-c class="clicked">{{family.f_name_kana}} {{family.l_name_kana}}</td-c>
            <template>
              <td-c class="clicked" v-if="family.pref === 0">未選択</td-c>
              <td-c class="clicked" v-if="family.pref === 1">北海道</td-c>
              <td-c class="clicked" v-if="family.pref === 2">青森県</td-c>
              <td-c class="clicked" v-if="family.pref === 3">秋田県</td-c>
              <td-c class="clicked" v-if="family.pref === 4">岩手県</td-c>
              <td-c class="clicked" v-if="family.pref === 5">山形県</td-c>
              <td-c class="clicked" v-if="family.pref === 6">宮城県</td-c>
              <td-c class="clicked" v-if="family.pref === 7">福島県</td-c>
              <td-c class="clicked" v-if="family.pref === 8">栃木県</td-c>
              <td-c class="clicked" v-if="family.pref === 9">山梨県</td-c>
              <td-c class="clicked" v-if="family.pref === 10">群馬県</td-c>
              <td-c class="clicked" v-if="family.pref === 11">茨城県</td-c>
              <td-c class="clicked" v-if="family.pref === 12">千葉県</td-c>
              <td-c class="clicked" v-if="family.pref === 13">埼玉県</td-c>
              <td-c class="clicked" v-if="family.pref === 14">東京都</td-c>
              <td-c class="clicked" v-if="family.pref === 15">神奈川県</td-c>
              <td-c class="clicked" v-if="family.pref === 16">静岡県</td-c>
              <td-c class="clicked" v-if="family.pref === 17">長野県</td-c>
              <td-c class="clicked" v-if="family.pref === 18">愛知県</td-c>
              <td-c class="clicked" v-if="family.pref === 19">岐阜県</td-c>
              <td-c class="clicked" v-if="family.pref === 20">新潟県</td-c>
              <td-c class="clicked" v-if="family.pref === 21">富山県</td-c>
              <td-c class="clicked" v-if="family.pref === 22">石川県</td-c>
              <td-c class="clicked" v-if="family.pref === 23">福井県</td-c>
              <td-c class="clicked" v-if="family.pref === 24">滋賀県</td-c>
              <td-c class="clicked" v-if="family.pref === 25">京都府</td-c>
              <td-c class="clicked" v-if="family.pref === 26">三重県</td-c>
              <td-c class="clicked" v-if="family.pref === 27">和歌山県</td-c>
              <td-c class="clicked" v-if="family.pref === 28">奈良県</td-c>
              <td-c class="clicked" v-if="family.pref === 29">大阪府</td-c>
              <td-c class="clicked" v-if="family.pref === 30">兵庫県</td-c>
              <td-c class="clicked" v-if="family.pref === 31">鳥取県</td-c>
              <td-c class="clicked" v-if="family.pref === 32">島根県</td-c>
              <td-c class="clicked" v-if="family.pref === 33">岡山県</td-c>
              <td-c class="clicked" v-if="family.pref === 34">広島県</td-c>
              <td-c class="clicked" v-if="family.pref === 35">山口県</td-c>
              <td-c class="clicked" v-if="family.pref === 36">高知県</td-c>
              <td-c class="clicked" v-if="family.pref === 37">徳島県</td-c>
              <td-c class="clicked" v-if="family.pref === 38">香川県</td-c>
              <td-c class="clicked" v-if="family.pref === 39">愛媛県</td-c>
              <td-c class="clicked" v-if="family.pref === 40">福岡県</td-c>
              <td-c class="clicked" v-if="family.pref === 41">佐賀県</td-c>
              <td-c class="clicked" v-if="family.pref === 42">長崎県</td-c>
              <td-c class="clicked" v-if="family.pref === 43">熊本県</td-c>
              <td-c class="clicked" v-if="family.pref === 44">宮崎県</td-c>
              <td-c class="clicked" v-if="family.pref === 45">大分県</td-c>
              <td-c class="clicked" v-if="family.pref === 46">鹿児島県</td-c>
              <td-c class="clicked" v-if="family.pref === 47">沖縄県</td-c>
            </template>
            <td-c class="clicked">{{family.address1}}{{family.address2}}</td-c>
            <td-c class="clicked">{{family.tel1}}</td-c>
            <td-c class="clicked">{{family.created_at.substring(0, 10)}}</td-c>
          </template>

          <template v-if="familyfile.family_id !== family.id">
            <td-c>{{family.id}}</td-c>
            <td-c>{{family.f_name}} {{family.l_name}}</td-c>
            <td-c>{{family.f_name_kana}} {{family.l_name_kana}}</td-c>
            <template>
              <td-c v-if="family.pref === 0">未選択</td-c>
              <td-c v-if="family.pref === 1">北海道</td-c>
              <td-c v-if="family.pref === 2">青森県</td-c>
              <td-c v-if="family.pref === 3">秋田県</td-c>
              <td-c v-if="family.pref === 4">岩手県</td-c>
              <td-c v-if="family.pref === 5">山形県</td-c>
              <td-c v-if="family.pref === 6">宮城県</td-c>
              <td-c v-if="family.pref === 7">福島県</td-c>
              <td-c v-if="family.pref === 8">栃木県</td-c>
              <td-c v-if="family.pref === 9">山梨県</td-c>
              <td-c v-if="family.pref === 10">群馬県</td-c>
              <td-c v-if="family.pref === 11">茨城県</td-c>
              <td-c v-if="family.pref === 12">千葉県</td-c>
              <td-c v-if="family.pref === 13">埼玉県</td-c>
              <td-c v-if="family.pref === 14">東京都</td-c>
              <td-c v-if="family.pref === 15">神奈川県</td-c>
              <td-c v-if="family.pref === 16">静岡県</td-c>
              <td-c v-if="family.pref === 17">長野県</td-c>
              <td-c v-if="family.pref === 18">愛知県</td-c>
              <td-c v-if="family.pref === 19">岐阜県</td-c>
              <td-c v-if="family.pref === 20">新潟県</td-c>
              <td-c v-if="family.pref === 21">富山県</td-c>
              <td-c v-if="family.pref === 22">石川県</td-c>
              <td-c v-if="family.pref === 23">福井県</td-c>
              <td-c v-if="family.pref === 24">滋賀県</td-c>
              <td-c v-if="family.pref === 25">京都府</td-c>
              <td-c v-if="family.pref === 26">三重県</td-c>
              <td-c v-if="family.pref === 27">和歌山県</td-c>
              <td-c v-if="family.pref === 28">奈良県</td-c>
              <td-c v-if="family.pref === 29">大阪府</td-c>
              <td-c v-if="family.pref === 30">兵庫県</td-c>
              <td-c v-if="family.pref === 31">鳥取県</td-c>
              <td-c v-if="family.pref === 32">島根県</td-c>
              <td-c v-if="family.pref === 33">岡山県</td-c>
              <td-c v-if="family.pref === 34">広島県</td-c>
              <td-c v-if="family.pref === 35">山口県</td-c>
              <td-c v-if="family.pref === 36">高知県</td-c>
              <td-c v-if="family.pref === 37">徳島県</td-c>
              <td-c v-if="family.pref === 38">香川県</td-c>
              <td-c v-if="family.pref === 39">愛媛県</td-c>
              <td-c v-if="family.pref === 40">福岡県</td-c>
              <td-c v-if="family.pref === 41">佐賀県</td-c>
              <td-c v-if="family.pref === 42">長崎県</td-c>
              <td-c v-if="family.pref === 43">熊本県</td-c>
              <td-c v-if="family.pref === 44">宮崎県</td-c>
              <td-c v-if="family.pref === 45">大分県</td-c>
              <td-c v-if="family.pref === 46">鹿児島県</td-c>
              <td-c v-if="family.pref === 47">沖縄県</td-c>
            </template>
            <td-c>{{family.address1}}{{family.address2}}</td-c>
            <td-c>{{family.tel1}}</td-c>
            <td-c>{{family.created_at.substring(0, 10)}}</td-c>
          </template>
        </tr-c>
      </table-c>
    </div>

    <h1 class="m-label m-label-custom" @click="switchV('column')" v-bind:class="{ 'slideActive': column }" v-ripple>項目
      <i class="fa fa-sort-alpha-desc"></i>ソート<i class="fa fa-fw fa-angle-down"></i>
      <span>
        <template v-if="this.sortColumn === 'id'">ID</template>
        <template v-if="this.sortColumn === 'family_id'">家庭ID</template>
        <template v-if="this.sortColumn === 'user'">登録者</template>
        <template v-if="this.sortColumn === 'file_name'">ファイル名</template>
        <template v-if="this.sortColumn === 'file'">ファイル</template>
        <template v-if="this.sortColumn === 'created_at'">作成日</template>
         : {{sortState}}
      </span>
    </h1>

    <template v-if="column">
      <div style="display: flex; flex-wrap: wrap">
        <btn class="m-btn--column" @click.native="reset()">RESET</btn>
        <btn class="m-btn--column" @click.native="all()">ALL</btn>
        <btn class="m-btn--column" @click.native="switchV('id')" v-bind:class="{ 'active': id }">ID</btn>
        <btn class="m-btn--column" @click.native="switchV('family_id')" v-bind:class="{ 'active': family_id }">家庭ID</btn>
        <btn class="m-btn--column" @click.native="switchV('user')" v-bind:class="{ 'active': user }">登録者</btn>
        <btn class="m-btn--column" @click.native="switchV('file_name')" v-bind:class="{ 'active': file_name }">ファイル名</btn>
        <btn class="m-btn--column" @click.native="switchV('file')" v-bind:class="{ 'active': file }">ファイル</btn>
        <btn class="m-btn--column" @click.native="switchV('created_at')" v-bind:class="{ 'active': created_at }">作成日</btn>
      </div>
    </template>

    <div style="display: flex" class=" FamilyfilesIndex_upload">
      <form class="upload_form" method="post" enctype="multipart/form-data" @submit.prevent="postFamilyfile" @keypress.stop.prevent.13>
        <input type="text" class="input" v-model="familyfile.family_id" placeholder="Family ID">
        <multiselect v-model="watch.file_name" :options="fileName" label="name" :show-labels="false" placeholder="ファイル名"></multiselect>
        <div class="box">
          <i class="fa fa-camera"></i>
          <input @change="selectedFile" type="file" id="file">
        </div>
        <btn type="submit" class="upload">アップロード</btn>
      </form>
    </div>

    <div class="index-box2 FamilyfilesIndex" @scroll="offset">
      <table-c>

        <tr-c slot="tr-th">
          <td-c></td-c>
          <td-c style="text-align: center">検索</td-c>
          <template v-if="id"><td-c><input v-model="search.id" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="family_id"><td-c><input v-model="search.family_id" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="user"><td-c><input v-model="search.user" type="text" @keyup="searchTable()"></td-c></template>
          <td-c class="select">
            <multiselect @select="searchTable()" v-model="watchSearch.file_name" :options="fileName" label="name" placeholder="" :show-labels="false"></multiselect>
          </td-c>
          <template v-if="file"><td-c></td-c></template>
          <template v-if="created_at"><td-c><input v-model="search.created_at" type="text" @keyup="searchTable()"></td-c></template>
        </tr-c>

        <tr-c slot="tr-th">
          <td-c></td-c>
          <td-c style="text-align: center">除外</td-c>
          <template v-if="id"><td-c><input v-model="search.not_id" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="family_id"><td-c><input v-model="search.not_family_id" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="user"><td-c><input v-model="search.not_user" type="text" @keyup="searchTable()"></td-c></template>
          <td-c class="select">
            <multiselect @select="searchTable()" v-model="watchSearch.not_file_name" :options="fileName" label="name" placeholder="" :show-labels="false"></multiselect>
          </td-c>
          <template v-if="file"><td-c></td-c></template>
          <template v-if="created_at"><td-c><input v-model="search.not_created_at" type="text" @keyup="searchTable()"></td-c></template>
        </tr-c>

        <tr-c slot="tr-th">
          <th-c style="text-align: center">削除</th-c>
          <th-c style="text-align: center">編集</th-c>
          <template v-if="id"><th-c @click.native='sort("id")'>ID</th-c></template>
          <template v-if="family_id"><th-c @click.native='sort("family_id")'>家庭ID</th-c></template>
          <template v-if="user"><th-c @click.native='sort("user")'>登録者</th-c></template>
          <template v-if="file_name"><th-c @click.native='sort("file_name")'>ファイル名</th-c></template>
          <template v-if="file"><th-c @click.native='sort("file")'>ファイル</th-c></template>
          <template v-if="created_at"><th-c @click.native='sort("created_at")'>作成日</th-c></template>
        </tr-c>

        <tr-c slot="tr-td" v-for="list in orderedFamilyfiles" :key="list.id" class="tr_hover FamilyfilesIndex_upload" v-bind:class="{ 'list-edit': list.id == edit_id.edit_id }">

          <template v-if="list.id == edit_id.edit_id">

            <td-c @click.native="cancelFamilyfile(list)" class="del">戻る</td-c>
            <td-c @click.native="patchFamilyfile(list)" class="del">更新</td-c>
            <template v-if="id"><td-c>{{list.id}}</td-c></template>
            <template v-if="family_id"><td-c>{{list.family_id}}</td-c></template>
            <template v-if="user"><td-c>{{list.user.user}}</td-c></template>
            <template v-if="file_name">
              <td-c class="select">
                <multiselect v-model="watchPatch.file_name" :options="fileName" label="name" :show-labels="false" placeholder=""></multiselect>
              </td-c>
            </template>
            <template v-if="file">
              <td-c>
                <form class="update_form" enctype="multipart/form-data">
                  <input @change="patchSelectedFile" type="file" id="file">
                </form>
              </td-c>
            </template>
            <template v-if="created_at"><td-c>{{list.created_at.substring(0, 10)}}</td-c></template>

          </template>

          <template v-if="list.id !== edit_id.edit_id">
            <td-c @click.native="deleteFamilyfile(list)" class="del">削除</td-c>
            <td-c @click.native="edit(list)" class="del">編集</td-c>
            <template v-if="id"><a v-bind:href="linkFamilyfile(list)" target="_blank" class="link">{{list.id}}</a></template>
            <template v-if="family_id"><a v-bind:href="linkFamilyfile(list)" target="_blank" class="link">{{list.family_id}}</a></template>
            <template v-if="user"><a v-bind:href="linkFamilyfile(list)" target="_blank" class="link">{{list.user.user}}</a></template>
            <template v-if="file_name">
              <a v-bind:href="linkFamilyfile(list)" target="_blank" class="link" v-if="list.file_name === 0">未選択</a>
              <a v-bind:href="linkFamilyfile(list)" target="_blank" class="link" v-if="list.file_name === 1">契約書</a>
              <a v-bind:href="linkFamilyfile(list)" target="_blank" class="link" v-if="list.file_name === 2">口座振替依頼書</a>
              <a v-bind:href="linkFamilyfile(list)" target="_blank" class="link" v-if="list.file_name === 3">指導カルテ</a>
              <a v-bind:href="linkFamilyfile(list)" target="_blank" class="link" v-if="list.file_name === 4">JIMカード</a>
              <a v-bind:href="linkFamilyfile(list)" target="_blank" class="link" v-if="list.file_name === 5">新規契約書類</a>
              <a v-bind:href="linkFamilyfile(list)" target="_blank" class="link" v-if="list.file_name === 6">APカード</a>
            </template>
            <template v-if="file"><a v-bind:href="linkFamilyfile(list)" target="_blank" class="link"></a></template>
            <template v-if="created_at"><a v-bind:href="linkFamilyfile(list)" target="_blank" class="link">{{list.created_at.substring(0, 10)}}</a></template>
          </template>

        </tr-c>
      </table-c>
    </div>
  </div>
</template>

<script>
import { getAPIURL } from '@/store/getters.js'
import config from '@/settings/config.js'
const url = getAPIURL() + '/api/v1/familyfiles/search?limit=' + config.LIMIT
const url2 = getAPIURL() + '/api/v1/families/search?limit=' + config.LIMIT

var obj = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  offset: config.LIMIT,
  max: config.LIMIT + 1,
  url: url,
  searchUrl: url,
  pageName: 'familyfile',
  pageNames: 'familyfiles'
}

var obj2 = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  offset: config.LIMIT,
  max: config.LIMIT + 1,
  url: url2,
  searchUrl: url2,
  pageName: 'family',
  pageNames: 'families'
}

let _ = window._
export default {
  data () {
    return {
      edit_id: {
        edit_id: ''
      },

      column: false,
      sortState: '降順',
      sortColumn: 'created_at',
      sortState2: '降順',
      sortColumn2: 'id',

      id: true,
      family_id: false,
      user: false,
      file_name: true,
      file: true,
      created_at: true,

      familyfile: {
        family_id: '',
        file_name: '',
        file: ''
      },

      watch: {
        file_name: ''
      },

      PatchFamilyfile: {
        file_name: '',
        file: ''
      },

      watchPatch: {
        file_name: ''
      },

      search: {
        id: '',
        family_id: '',
        user: '',
        file_name: '',
        created_at: '',
        not_id: '',
        not_family_id: '',
        not_user: '',
        not_file_name: '',
        not_created_at: ''
      },

      watchSearch: {
        file_name: '',
        not_file_name: ''
      },

      search2: {
        id: '',
        name: '',
        kana: '',
        pref: '',
        address: '',
        tel1: '',
        created_at: '',
        not_id: '',
        not_name: '',
        not_kana: '',
        not_pref: '',
        not_address: '',
        not_tel1: '',
        not_created_at: ''
      },

      watchSearch2: {
        pref: '',
        not_pref: ''
      },

      fileName: [
        { name: '未選択', value: 0 },
        { name: '契約書', value: 1 },
        { name: '口座振替依頼書', value: 2 },
        { name: '指導カルテ', value: 3 },
        { name: 'JIMカード', value: 4 },
        { name: '新規契約書類', value: 5 },
        { name: 'APカード', value: 6 }
      ],

      pref: [
        { name: '未選択', value: 0 },
        { name: '北海道', value: 1 },
        { name: '青森県', value: 2 },
        { name: '秋田県', value: 3 },
        { name: '岩手県', value: 4 },
        { name: '山形県', value: 5 },
        { name: '宮城県', value: 6 },
        { name: '福島県', value: 7 },
        { name: '栃木県', value: 8 },
        { name: '山梨県', value: 9 },
        { name: '群馬県', value: 10 },
        { name: '茨城県', value: 11 },
        { name: '千葉県', value: 12 },
        { name: '埼玉県', value: 13 },
        { name: '東京都', value: 14 },
        { name: '神奈川県', value: 15 },
        { name: '静岡県', value: 16 },
        { name: '長野県', value: 17 },
        { name: '愛知県', value: 18 },
        { name: '岐阜県', value: 19 },
        { name: '新潟県', value: 20 },
        { name: '富山県', value: 21 },
        { name: '石川県', value: 22 },
        { name: '福井県', value: 23 },
        { name: '滋賀県', value: 24 },
        { name: '京都府', value: 25 },
        { name: '三重県', value: 26 },
        { name: '和歌山県', value: 27 },
        { name: '奈良県', value: 28 },
        { name: '大阪府', value: 29 },
        { name: '兵庫県', value: 30 },
        { name: '鳥取県', value: 31 },
        { name: '島根県', value: 32 },
        { name: '岡山県', value: 33 },
        { name: '広島県', value: 34 },
        { name: '山口県', value: 35 },
        { name: '高知県', value: 36 },
        { name: '徳島県', value: 37 },
        { name: '香川県', value: 38 },
        { name: '愛媛県', value: 39 },
        { name: '福岡県', value: 40 },
        { name: '佐賀県', value: 41 },
        { name: '長崎県', value: 42 },
        { name: '熊本県', value: 43 },
        { name: '宮崎県', value: 44 },
        { name: '大分県', value: 45 },
        { name: '鹿児島県', value: 46 },
        { name: '沖縄県', value: 47 }
      ]
    }
  },
  computed: {
    obj () {
      return obj
    },

    familyfiles () {
      return this.$store.getters.familyfiles
    },

    orderedFamilyfiles () {
      if (this.sortState === '' || this.sortState === '降順') {
        return _.orderBy(this.familyfiles, this.sortColumn).reverse()
      } else if (this.sortState === '昇順') {
        return _.orderBy(this.familyfiles, this.sortColumn)
      }
    },

    families () {
      return this.$store.getters.families
    },

    orderedFamilies () {
      if (this.sortState2 === '' || this.sortState2 === '降順') {
        return _.orderBy(this.families, this.sortColumn2).reverse()
      } else if (this.sortState2 === '昇順') {
        return _.orderBy(this.families, this.sortColumn2)
      }
    }
  },
  watch: {
    'watch.file_name': function (now, old) {
      if (now) {
        this.familyfile.file_name = now.value
      } else {
        this.familyfile.file_name = ''
      }
    },

    'watchPatch.file_name': function (now, old) {
      if (now) {
        this.PatchFamilyfile.file_name = now.value
      } else {
        this.PatchFamilyfile.file_name = ''
      }
    },

    'watchSearch.file_name': function (now, old) {
      if (now) {
        this.search.file_name = now.value
      } else {
        this.search.file_name = ''
      }
    },

    'watchSearch.not_file_name': function (now, old) {
      if (now) {
        this.search.not_file_name = now.value
      } else {
        this.search.not_file_name = ''
      }
    },

    'watchSearch2.pref': function (now, old) {
      if (now) {
        this.search2.pref = now.value
      } else {
        this.search2.pref = ''
      }
    },

    'watchSearch2.not_pref': function (now, old) {
      if (now) {
        this.search2.not_pref = now.value
      } else {
        this.search2.not_pref = ''
      }
    }
  },
  methods: {
    select (selectedOption, id) {
      // console.log(selectedOption)
    },

    linkFamilyfile (list) {
      let URL = config['production'].url
      if (process.env.NODE_ENV === 'development') {
        URL = 'http://localhost:8080'
      }
      let link = URL + '#/familyfile/view/' + list.id
      return link
    },

    switchV (col) {
      this[col] = !this[col]
    },

    reset () {
      this.id = false
      this.family_id = false
      this.user = false
      this.file_name = false
      this.file = false
      this.created_at = false
    },

    all () {
      this.id = true
      this.family_id = true
      this.user = true
      this.file_name = true
      this.file = true
      this.created_at = true
    },

    // order By
    sort (header) {
      if (this.sortState === '' || this.sortState === '降順') {
        this.sortState = '昇順'
        this.sortColumn = header
      } else if (this.sortState === '昇順') {
        this.sortState = '降順'
        this.sortColumn = header
      }
    },

    sort2 (header) {
      if (this.sortState2 === '' || this.sortState2 === '降順') {
        this.sortState2 = '昇順'
        this.sortColumn2 = header
      } else if (this.sortState2 === '昇順') {
        this.sortState2 = '降順'
        this.sortColumn2 = header
      }
    },

    offset (e) {
      this.$store.dispatch('SCROLL', {
        this: this,
        e: e,
        obj: obj
      })
    },

    searchTable (e) {
      this.$store.dispatch('SEARCH', {
        this: this,
        e: e,
        obj: obj
      })
    },

    searchTable2 (e) {
      this.$store.dispatch('SEARCH2', {
        this: this,
        e: e,
        obj: obj2
      })
    },

    edit (list) {
      this.edit_id.edit_id = list.id
      this.watchPatch.file_name = this.fileName[list.file_name]
    },

    selectedFile (e) {
      e.preventDefault()
      let files = e.target.files
      this.familyfile.file = files[0]
    },

    patchSelectedFile (e) {
      e.preventDefault()
      let files = e.target.files
      this.PatchFamilyfile.file = files[0]
    },

    postFamilyfile () {
      this.$store.dispatch('postFamilyfile', {
        this: this,
        familyfile: this.familyfile
      })
    },

    deleteFamilyfile (list) {
      this.$store.dispatch('deleteFamilyfile', {
        this: this,
        list: list
      })
    },

    cancelFamilyfile (list) {
      this.$store.dispatch('cancelFamilyfile', {
        this: this,
        list: list,
        edit_id: this.edit_id
      })
    },

    patchFamilyfile (list) {
      this.$store.dispatch('patchFamilyfile', {
        this: this,
        list: list,
        edit_id: this.edit_id,
        familyfile: this.PatchFamilyfile
      })
    },

    getId (family) {
      this.familyfile.family_id = family.id
    }
  }
}
</script>

<style lang="scss" scoped>
.link {
  text-decoration: none;
  display: table-cell;
  vertical-align: middle;
  border-bottom: solid 1px #ccc;
  border-right: solid 1px #ccc;
  padding: .5rem;
}
.clicked {
  background: #41B883;
  font-weight: bold;
  color: #fff;
}
.index-box {
  height: calc(50vh - 110px);
  overflow: scroll;
  margin-top: 10px;
}
.index-box2 {
  height: calc(50vh - 120px);
  overflow: scroll;
  margin-top: 10px;
}
.upload_form {
  width: 700px;
  display: flex;
  .input {
    border: solid 1px #ccc;
    width: 150px;
    height: 36px;
    padding: 10px;
  }
  .box {
    position: relative;
    .fa-camera {
      color: #ccc;
      font-size: 25px;
      padding: 7px;
      height: 36px;
      position: absolute;
      top: 0;
    }
    width: 100%;
    input[type="file"] {
      height: 36px;
      -webkit-appearance: none;
      appearance: none;
      border: solid 1px #ccc;
    }
    input[type="file"]::-webkit-file-upload-button {
      width: 36px;
      height: 36px;
      opacity: 0;
      -webkit-appearance: none;
      appearance: none;
    }
  }
}
.upload {
  border: solid 1px #37474F;
  height: 36px;
  min-width: 100px;
  text-align: center;
  padding-top: 8px;
  background: #37474F;
  color: #fff;
}
.update_form {
}
.m-label-custom {
  z-index: 1;
  cursor: pointer;
  margin-bottom: 1px;
}
.slideActive {
  background: #455A64;
  color: #fff;
}
.active {
  background: #455A64;
  border: solid 1px #455A64;
  color: #fff;
}
.resetSearch {
  padding: 7px 0;
}
.table {
  margin-top: 0 !important;
}
.th, .td {
  padding: 0.5rem 0.5rem !important;
  border-right: solid 1px #ccc;
  min-width: 60px;
}
.th {
  cursor: pointer;
}
.select {
  padding: 0 !important;
}
input {
  width: 100%;
  min-width: 100px;
  height: 100%;
  padding: 0;
  outline: 0;
  border: none;
}
.del {
  text-align: center;
  cursor: pointer;
  &:hover {
    background: black;
    color: white;
  }
}
</style>

<style lang="scss">
.FamilyfilesIndex {
  .multiselect {
    min-height: 23px;
    min-width: 100px;
  }
  .multiselect__tags {
    border: solid 1px #ccc;
    min-height: 23px;
    padding: 0px 23px 0 2px;
    border-radius: 0;
    border: none;
  }
  .multiselect__tags-wrap {
    background: red;
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 23px;
  }
  .multiselect__select {
    height: 23px;
    width: 26px;
    top: 2px;
    padding: 0;
    &:before {
      top: 65%;
    }
  }
  .multiselect__single {
    margin-top: 3px;
    margin-bottom: 3px;
  }
}
</style>

<style lang="scss">
.FamilyfilesIndex_upload {
  .multiselect {
    min-height: 36px;
  }
  .multiselect__tags {
    border: solid 1px #ccc;
    border-radius: 0;
    min-height: 36px;
    padding: 0px 40px 0 2px;
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 36px;
  }
  .multiselect__select {
    height: 36px;
  }
  .multiselect__single {
    margin-top: 7px;
    margin-bottom: 7px;
  }
  .multiselect__placeholder {
    padding: 11px 3px;
    margin: 0;
    font-size: .85rem;
    color: #ccc;
  }
}
</style>



// WEBPACK FOOTER //
// FamilyfilesIndex.vue?3cc909a0